/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeAccordion, BaSeSmall1, BaSeTheme } from '@base/react';
import * as React from 'react';
import Comments from './comments/comments';
import PersonalItems from './personal-items';

export const Item = ({ name, id, comments, active, hidePortal, color }) => {
  const handleContent = () => {
    return (
      <div style={{ padding: '10px 0' }}>
        <BaSeAccordion
          options={[
            {
              title: () => {
                return <BaSeSmall1>Dados do participante</BaSeSmall1>;
              },

              content: <PersonalItems id={id} />,
            },

            {
              title: () => {
                return <BaSeSmall1>Comentários relevantes</BaSeSmall1>;
              },

              content: <Comments comments={comments} idInterview={id} />,
            },
          ]}
          titleColor="#303030"
          shadow="0"
          backgroundContentColor="#ffffff"
        />
      </div>
    );
  };

  const COLOR = color ? color : '#355eb4';
  return (
    <>
      <BaSeAccordion
        backgroundContentColor={BaSeTheme.colors.defaultColors.white}
        backgroundTitleColor={COLOR}
        preserveContent={true}
        options={[
          {
            title: ({ open, setOpen, color }) => {
              return (
                <BaSeSmall1 color={BaSeTheme.colors.defaultColors.white} isBold>
                  {name}
                </BaSeSmall1>
              );
            },

            content: handleContent(),
          },
        ]}
        titleColor={BaSeTheme.colors.defaultColors.white}
        clickableTitle={true}
      />
    </>
  );
};
